/**
 * @type interface
 */
export interface IStoreState {
	coachMarksSeen: string[];
	foo: string;
}

/**
 * @class State
 * @package Store/Module/UserGuidance
 * @project ChalkySticks SDK Vue2.0 Components
 */
const state: IStoreState = {
	coachMarksSeen: [],
	foo: 'bar',
};

export default state;
